// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function getNetworkState() {
  var conn = navigator.connection;
  if (conn == null) {
    return "NOT_AVAILABLE";
  } else {
    return {
            TAG: "Value",
            _0: {
              isOnline: navigator.onLine,
              effectiveType: conn.effectiveType,
              downlink: conn.downlink,
              rtt: conn.rtt
            }
          };
  }
}

function useNetworkInformation() {
  var match = React.useState(function () {
        return "NOT_AVAILABLE";
      });
  var setNetworkState = match[1];
  React.useEffect((function () {
          var updateNetState = function () {
            var conn = navigator.connection;
            if (conn == null) {
              return setNetworkState(function (param) {
                          return "NOT_AVAILABLE";
                        });
            } else {
              return setNetworkState(function (param) {
                          return {
                                  TAG: "Value",
                                  _0: {
                                    isOnline: navigator.onLine,
                                    effectiveType: conn.effectiveType,
                                    downlink: conn.downlink,
                                    rtt: conn.rtt
                                  }
                                };
                        });
            }
          };
          window.addEventListener("load", updateNetState);
          window.addEventListener("online", updateNetState);
          window.addEventListener("offline", updateNetState);
          return (function () {
                    window.removeEventListener("load", updateNetState);
                    window.removeEventListener("online", updateNetState);
                    window.removeEventListener("offline", updateNetState);
                  });
        }), []);
  return match[0];
}

var defaultNetworkState = {
  isOnline: true,
  effectiveType: "",
  downlink: 0,
  rtt: 0
};

export {
  defaultNetworkState ,
  getNetworkState ,
  useNetworkInformation ,
}
/* react Not a pure module */
